module.exports = __webpack_public_path__ + "static/media/crying-face-svgrepo-com.7dd0a4f7.svg";